import moment from 'moment';

/**
 * Tag disponibili per template: template_ddt_supplier
 *
 * TESTATA:
 *   {internalCode}   - Codice interno DDT
 *   {date}           - Data DDT (DD/MM/YYYY)
 *   {supplierCode}   - Codice fornitore
 *   {supplierVat}    - P.IVA fornitore
 *   {supplierName}   - Nome fornitore
 *   {supplierAddress}- Indirizzo fornitore
 *   {rifOrder}       - Riferimento ordine fornitore
 *   {address}        - Indirizzo consegna
 *   {transportReason}- Causale trasporto
 *
 * RIGHE (loop {#rows}...{/rows}):
 *   {code}      - Codice articolo
 *   {name}      - Descrizione articolo
 *   {um}        - Unita di misura
 *   {quantity}  - Quantita
 *   {notes}     - Note riga
 *
 * TRASPORTO:
 *   {itemsAspect}      - Aspetto dei beni
 *   {packagesQuantity} - Numero colli
 *   {weight}           - Peso
 *   {transportBy}      - Trasporto a cura di
 *   {forwarderName}    - Nome corriere
 *   {annotazioni}      - Annotazioni
 *
 * Extra args: rifOrder, address
 */

function getTransportBy(val) {
    if (!val) return '';
    const v = val.value || val.label || val;
    if (v === '0_SENDER') return 'Mittente';
    if (v === '1_RECIPIENT') return 'Destinatario';
    if (v === '2_CARRIER') return 'Vettore';
    return '';
}

function getItemsAspect(val) {
    if (!val) return '';
    const v = val.value || val.label || val;
    if (v === '0_SCATOLE') return 'Scatole';
    if (v === '5_VISTA') return 'A Vista';
    if (v === '10_PLURIBOL') return 'Pluribol';
    if (v === '15_CARTONI') return 'Cartoni';
    return v;
}

export default {
    tags: {
        internalCode: 'internalCode',
        supplierCode: 'idSupplier.code',
        supplierVat: 'idSupplier.vatNumber',
        supplierName: 'idSupplier.name',
        supplierAddress: 'idSupplier.address',
        transportReason: 'idTransportDocumentReason.name',
        packagesQuantity: 'packagesQuantity',
        weight: 'weight',
        forwarderName: 'idForwarder.name',
        annotazioni: 'notes',
    },

    rows: {
        source: 'rows',
        tags: {
            code: 'idItemModel.code',
            name: { paths: ['idItemModel.name', 'name'] },
            um: 'measureUnit',
            quantity: 'quantity',
            notes: 'notes',
        }
    },

    computed: (data, rifOrder, address) => {
        return {
            date: (data.documentDate || data.date) ? moment(data.documentDate || data.date).format('DD/MM/YYYY') : '',
            rifOrder: rifOrder || '',
            address: address || '',
            transportBy: getTransportBy(data.transportBy),
            itemsAspect: getItemsAspect(data.itemsAspect),
        };
    }
};
